/**
 * Route for `adjust-postback-template`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { AdjustPostbackTemplatePage } from "../features/adjust-postback-template/AdjustPostbackTemplatePage";

export const adjustPostbackTemplateRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/adjust-postback-template",
	component: AdjustPostbackTemplatePage,
});

export default adjustPostbackTemplateRoute;
